import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse, NotFoundError } from "./ApiClient";
import { ExpenseNoteFormData, ExpenseNoteRelatedAttributes } from "@/formTypes/ExpenseNoteDataType";
import { ExpenseNoteFormDataKeys } from "@/generated/ExpenseNoteFormDataKeys";
import { getTenantId } from "@utils/Auth";

export type ExpenseNoteDataType = Partial<ApiSchema["ExpenseNote"]["type"] & ExpenseNoteFormData>;

class Api extends GenericModelApi<"ExpenseNote", ExpenseNoteDataType> {

    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ExpenseNoteDataType>> {
        const selectionSet = [
            ...ExpenseNoteFormDataKeys.filter(k => !ExpenseNoteRelatedAttributes.includes(k)),
            "currency.*",
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async getExpenseNoteByDocumentKey(
        documentKey: string,
        selectionSet?: any
    ): Promise<ExpenseNoteDataType> {
        const tenantId = await getTenantId();

        const collected: ExpenseNoteDataType[] = [];

        const fetchFunction = ApiClient.models[this.modelName].listExpenseNoteByDocumentKeyTenant;
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            document_key: { eq: documentKey },
        }, {
            limit: 1,
            selectionSet: selectionSet,
        });

        if (errors) {
            throw new ApiError("Error al obtener la Nota de Credito del Gasto", "API_ERROR", errors);
        }

        const pageItems = (data || [])
        if (pageItems.length > 0) {
            return pageItems[0]
        }

        throw new NotFoundError(`No existe ninguna Nota de Credito del Gasto con el codigo la clave ${documentKey} `, "API_ERROR", errors);
    }
}
export const ExpenseNoteApi = new Api("ExpenseNote", "numero")